import { useQuery } from "@tanstack/react-query";

import { notificationsApi } from "@/features/engagement/services/notifications.api";
import { useAppSelector } from "@/store/hooks";

/** Powers the bell badge in `AuthenticatedLayout`'s header — rendered on
 * every authenticated page, so it stays a cheap dedicated endpoint rather
 * than piggybacking on the full notifications list. */
export function useUnreadNotificationCount() {
  const isAuthenticated = useAppSelector((state) => state.auth.status === "authenticated");
  return useQuery({
    queryKey: ["notifications", "unread-count"],
    queryFn: notificationsApi.getUnreadCount,
    enabled: isAuthenticated,
  });
}
